export enum SipPlansPlanType {
  SIP = 'SIP',
  IDEAL = 'IDEAL'
}

/**
 * Pre-plan + rolled-out lifecycle for SIP tabs (Your Plan / Ideal).
 * Same values and meanings as lumpsum `LumpsumPlanStatus`.
 */
export enum SipPlanStatus {
  QUESTIONNAIRE_NOT_INITIATED = 'QUESTIONNAIRE_NOT_INITIATED',
  QUESTIONNAIRE_IN_PROGRESS = 'QUESTIONNAIRE_IN_PROGRESS',
  QUESTIONNAIRE_SUBMITTED = 'QUESTIONNAIRE_SUBMITTED',
  QUESTIONNAIRE_RE_SUBMITTED = 'QUESTIONNAIRE_RE_SUBMITTED',
  PLAN_ROLLED_OUT = 'PLAN_ROLLED_OUT'
}

export enum SipRecommendationActionType {
  STOP = 'STOP',
  START = 'START',
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE'
}

export enum SipRecommendationType {
  ACTIONABLE = 'ACTIONABLE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  EXECUTED = 'EXECUTED',
  INVALIDATED = 'INVALIDATED',
  NO_ACTION = 'NO_ACTION'
}

export enum SipRecommendationStatus {
  NEW = 'NEW',
  UPDATED = 'UPDATED',
  SAME = 'SAME',
  INVALIDATED = 'INVALIDATED'
}

export type SipSystematicStatusResponse = {
  activeSipCount?: number | null
  activeSipAmount?: number | null
}

export interface SipIdealAllocation {
  absolute?: number | null
  upperLimit?: number | null
  lowerLimit?: number | null
}

export interface SipFund {
  isin?: string | null
  mfLogoUrl?: string | null
  fundName?: string | null
  fundNature?: string | null
  fundCategory?: string | null
  purchaseMode?: string | null
  distributionStatus?: string | null
  currentSipAmount?: number | null
  powerupSipAmount?: number | null
  externalSipAmount?: number | null
  infiniteSipAmount?: number | null
  powerRank?: number | null
  powerRating?: string | null
  taxCategory?: string | null
}
